/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ListSourcesResult = {
  /**
   * The distinct agent sources present in this project's chats (raw source strings such as 'claude-code', 'Codex', 'playground').
   */
  sources: Array<string>;
};

/** @internal */
export const ListSourcesResult$inboundSchema: z.ZodMiniType<
  ListSourcesResult,
  unknown
> = z.object({
  sources: z.array(z.string()),
});

export function listSourcesResultFromJSON(
  jsonString: string,
): SafeParseResult<ListSourcesResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListSourcesResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListSourcesResult' from JSON`,
  );
}
